<template>
  <v-row>
    <v-col class="pa-1">
      <!-- tool bar -->
      <v-card
          color="grey lighten-4"
          flat
          style="margin-bottom: 6px;"
          tile
      >
        <v-app-bar
          dense
          fixed
          color="elevation-1"
          style="margin-top:70px;"
        >
          <v-row no-gutters>
            <v-col class="d-flex pa-0">
              <v-autocomplete
                v-model="location_selected"
                :items="locations_list"
                item-text="name"
                item-value="_guid"
                label="All locations"
                dense
                solo
                clearable
                hide-details
                style="max-width:340px"
              >
                <template
                  slot="selection"
                  slot-scope="data"
                >
                  <div>
                    <div v-html="data.item.name" />
                  </div>
                </template>
                <template
                  slot="item"
                  slot-scope="data"
                >
                  <!-- Divider and Header-->
                  <!-- Area item (group) -->
                  <template v-if="data.item._guid.type == TYPE_AREA">
                    <div class="select-drop-item-group__area">
                      <div v-html="data.item.name" />
                    </div>
                  </template>
                  <!-- Restaurant item (sub group) -->
                  <template v-else>
                    <div class="select-drop-item-sub_restaurant">
                      <div v-html="data.item.name" />
                    </div>
                  </template>
                </template>
              </v-autocomplete>

              <div style="margin-left:4px">
                <v-btn @click="onPreviosRange">
                  <v-icon>mdi-menu-left</v-icon>
                </v-btn>

                <v-menu
                  v-model="menu_date_picker"
                  transition="scale-transition"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on">
                      {{dateRangeText(date_range_selected)}}
                    </v-btn>
                  </template>

                  <v-card max-width="346px">
                    <v-date-picker
                      v-model="date_range_selected"
                      scrollable
                      actions
                      full-width
                      first-day-of-week="1"
                      range
                      :title-date-format="dateRangeText"
                      v-on:click:date="dateRangeSelect"
                    ></v-date-picker>

                    <v-divider></v-divider>

                  </v-card>
                </v-menu>

                <v-btn @click="onNextRange">
                  <v-icon>mdi-menu-right</v-icon>
                </v-btn>
              </div>

              <v-select
                v-model="interval_selected_id"
                :items="interval_list"
                item-text="name"
                item-value="id"
                @change="onSelectInterval"
                dense
                solo
                hide-details
                style="max-width:150px; margin-left:4px;"
              ></v-select>

              <v-select
                v-model="status_selected_id"
                :items="status_list"
                item-text="name"
                item-value="id"
                @change="onSelectInterval"
                prepend-inner-icon="mdi-filter"
                :background-color="statusColor"
                dense
                solo
                hide-details
                style="max-width:150px; margin-left:4px;"
              ></v-select>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>

          <v-row no-gutters>
            <v-col class="d-flex justify-end pa-0">
              <new-timesheet-modal></new-timesheet-modal>
              <v-btn
                @click="approvePeriodTimesheets"
                :loading="approvePeriodLoading"
                >
                <v-icon>mdi-post</v-icon>&nbsp;Approve All&nbsp;[{{unapprovedTimesheets}}]
              </v-btn>
              <v-btn
                      @click="generateInvoice"
                      :disabled="!date_range_selected || !location_selected || location_selected.type != TYPE_RESTAURANT"
              >
              <v-icon>mdi-file-document-outline</v-icon>Invoice
              </v-btn>
              <v-btn
                      @click="xlsExportTimesheets"
                      :loading="xlsExportLoading"
                      :disabled="!date_range_selected"
              >
                <v-icon>mdi-file-document-outline</v-icon>XLS Payments
              </v-btn>

            </v-col>
          </v-row>
        </v-app-bar>
      </v-card>
      <!--/ tool bar -->
      <!-- body -->
      <div
        class="d-flex mb-auto"
        flat
        tile
      >
        <!-- toggle left panel -->
        <v-navigation-drawer
          permanent
          clipped
          left
          fixed
          width="256"
          :height="scroll_panel_height"
          style="margin-top:122px;"
        >
          <template v-slot:prepend>
            <v-list dense>
              <v-list-item
                link
                two-line
              >
                <v-list-item-content>
                  <v-list-item-title class="title" style="padding-bottom:1px;padding-top:12px;">
                    <v-text-field
                      v-model="search_driver"
                      label="Search"
                      hide-details
                      append-outer-icon="mdi-magnify"
                      dense
                    ></v-text-field>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>

          <v-divider></v-divider>

          <v-list dense class="driver-list_leftpanel">
            <v-list-item
              v-for="(item, i) in driverListSearched"
              :key="i"
              @click="onChangeDriver(item)"
              :input-value="selected_driver && selected_driver.id == item.id"
              color="primary"
            >
              <!-- <v-list-item-icon class="driver-profile_icon">
                <img v-if="item.photo_src" :src="appConfig.app_url + '/images/thumb/' + item.photo_src" class="driver-photo_src">
                <v-icon v-if="!item.photo_src">mdi-account</v-icon>
              </v-list-item-icon> -->
              <v-list-item-content>
                <v-list-item-title v-html="item.full_name"></v-list-item-title><v-list-item-title v-html="item.phone"></v-list-item-title>
                <v-list-item-subtitle v-if="item.id != -1 && driver_list_calc && driver_list_calc[item.id]">[{{driver_list_calc[item.id].timesheets}}]&nbsp;{{driver_list_calc[item.id].hours | formatHours}}Hrs/£{{driver_list_calc[item.id].cost | formatFloat}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>
        <!--/ toggle left panel -->
        <!-- right panel work area -->
        <v-card
          class="right-panel-work-area"
          outlined
          tile
        >
          <v-card
            color="elevation-1"
            class="time-sheet-table mb-2"
            tile
            :style="fixed_panel ? 'padding-bottom: ' + (tool_bar_timesheet_form_height - 25) + 'px;' : ''"
          >
            <!-- headers -->
            <v-card
              color="elevation-1"
              class="time-sheet-table__header"
              style="margin-bottom:2px;"
              tile
            >
              <v-row
                no-gutters
              >
                <v-col class="col-1 pa-1 pl-2" style="max-width: 98px; min-width: 98px;">Date</v-col>
                <v-col class="pa-1 flex-grow-1 flex-shrink-0">Driver</v-col>
                <v-col class="col-1 pa-1" style="max-width: 100px; min-width: 100px;">Status</v-col>
                <v-col class="col-1 pa-1" style="max-width: 150px; min-width: 150px;">Progress</v-col>
                <v-col class="pa-1 flex-grow-1 flex-shrink-0">Location</v-col>
                <v-col class="col-2 pa-1" style="min-width: 104px; max-width: 104px;">Time</v-col>
                <v-col class="col-1 pa-1" style="min-width: 90px; max-width: 90px;">Hours</v-col>
                <v-col class="col-2 pa-1" style="min-width: 190px; max-width: 190px;">Earned (+£bonus)</v-col>
              </v-row>
            </v-card>
            <!--/ headers -->
            <!-- body -->
            <v-card
              color="elevation-1"
              style="margin-bottom: 1px; cursor: pointer;"
              no-gutters
              tile
              class="time-sheet-table__line"
              :class="[{'blue-grey lighten-3': select_time_sheet_index == index}, 'timeSheetItem_' + index]"
              v-for="(item, index) in timesheetListSearchedFilterDriver"
              :key="item.id"
              @click="onSelectTimeSheet(index)"
            >
              <v-row align="stretch">
                <v-col class="col-1 pa-1 pl-2" style="max-width: 98px; min-width: 98px;">{{item.period_date | headerDate}}</v-col>
                <v-col class="pa-1 flex-grow-1 flex-shrink-0">{{getDrvierNameById(item.driver_id)}}</v-col>
                <v-col class="col-1 pa-1" style="max-width: 100px; min-width: 100px;">
                  <v-btn
                      outlined
                      color="white"
                      :class="{
                        'orange': item.status == STATUS_PENDING,
                        'red accent-4': item.status == STATUS_DISCARDED,
                        'green': item.status == STATUS_APPROVED
                      }"
                      small
                      v-if="area_list.length!==0"
                  >
                    <span v-if="item.status == STATUS_PENDING">Pending</span>
                    <span v-if="item.status == STATUS_DISCARDED">Discarded</span>
                    <span v-if="item.status == STATUS_APPROVED">Approved</span>
                  </v-btn>
                </v-col>
                <v-col class="col-1 pa-1" style="max-width: 150px; min-width: 150px;">
                  <v-btn
                      outlined
                      color="white"
                      :class="{
                        'blue': item.status_progress == STATUS_PROGRESS_IN_WORK,
                        'orange': item.status_progress == STATUS_PROGRESS_SUBMITED,
                        'blue-grey lighten-4': item.status_progress == STATUS_PROGRESS_NOT_SUBMITED && +item.driver_id === 0,
                        'blue-grey': item.status_progress == STATUS_PROGRESS_NOT_SUBMITED && +item.driver_id !== 0,
                        'green': item.status_progress == STATUS_PROGRESS_PAY_APPROVED,
                        'deep-orange': item.status_progress == STATUS_PROGRESS_TIME_APPROVED,
                        'red darken-4': item.status_progress == STATUS_PROGRESS_DISCARDED,
                        'pink darken-4': item.status_progress == STATUS_PROGRESS_DISCARDED_BY_DRIVER,
                      }"
                      small
                      v-if="area_list.length!==0"
                  >
                    <span v-if="item.status_progress == STATUS_PROGRESS_IN_WORK">In work</span>
                    <span v-if="item.status_progress == STATUS_PROGRESS_SUBMITED">Submited</span>
                    <span v-if="item.status_progress == STATUS_PROGRESS_NOT_SUBMITED && +item.driver_id === 0">Open shift</span>
                    <span v-if="item.status_progress == STATUS_PROGRESS_NOT_SUBMITED && +item.driver_id !== 0">Not submited</span>
                    <span v-if="item.status_progress == STATUS_PROGRESS_PAY_APPROVED">Pay approved</span>
                    <span v-if="item.status_progress == STATUS_PROGRESS_TIME_APPROVED">Time approved</span>
                    <span v-if="item.status_progress == STATUS_PROGRESS_DISCARDED">Discarded</span>
                    <span v-if="item.status_progress == STATUS_PROGRESS_DISCARDED_BY_DRIVER">Discarded by driver</span>
                  </v-btn>
                </v-col>
                <v-col class="pa-1 flex-grow-1 flex-shrink-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        {{getRestaurantNameByID(item.restaurant_id)}}
                      </span>
                    </template>
                    <span>{{getAreaLabel(item.restaurant_id)}}</span>
                  </v-tooltip>
                </v-col>
                <v-col class="col-2 pa-1" style="min-width: 104px; max-width: 104px;">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        {{item.start_time | formatTime}} - {{item.finish_time | formatTime}}
                      </span>
                    </template>
                    <span>{{item.driver_start_time | formatTime}} - {{item.driver_finish_time | formatTime}}</span>
                  </v-tooltip>
                </v-col>
                <v-col class="col-1 pa-1" style="min-width: 90px; max-width: 90px;">{{getShiftHours(item) | formatHours}} Hrs</v-col>
                <!-- EARNED COL -->
                <v-col class="col-2 pa-1" style="min-width: 190px; max-width: 190px;">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <span v-if="(+item.cost_total - +item.cost_bonus - +item.const_fuel_bonus) < 0">-£{{ Math.abs(+item.cost_total - +item.cost_bonus - +item.const_fuel_bonus).toFixed(2) }}</span>
                        <span v-else>£{{(+item.cost_total - +item.cost_bonus - +item.const_fuel_bonus) | formatFloat}}</span>
                      </span>
                    </template>
                    <span>{{item.cost_per_hour}}£ / Hr</span>
                  </v-tooltip>

                  &nbsp;
                  <span class="bonus-plus" v-if="+item.cost_bonus > 0">&nbsp;+£{{ item.cost_bonus }} </span>
                  <span class="bonus-minus" v-if="+item.cost_bonus < 0">&nbsp;-£{{ Math.abs(item.cost_bonus.toFixed(0)) }}</span>
                  <span class="bonus-plus" v-if="+item.const_fuel_bonus > 0">&nbsp;+£{{ item.const_fuel_bonus }} </span>
                  <span class="bonus-minus" v-if="+item.const_fuel_bonus < 0">&nbsp;-£{{ item.const_fuel_bonus < 0 ? Math.floor(Math.abs(item.const_fuel_bonus) * 100) * -1 / 100 : Math.abs((item.const_fuel_bonus).toFixed(0)) }}</span>
                  <span class="bonus-plus" v-if="+item.cost_extra_bonus > 0">&nbsp;+£{{ item.cost_extra_bonus }} </span>
                  <span class="bonus-minus" v-if="+item.cost_extra_bonus < 0">&nbsp;-£{{ Math.abs(item.cost_extra_bonus.toFixed(0)) }}</span>
                  &nbsp;
                  <span v-if="(+item.cost_total + +item.cost_extra_bonus) < 0" class="cost-total-result">-£{{ Math.abs(+item.cost_total+ +item.cost_extra_bonus).toFixed(2) }}</span>
                  <span v-else class="cost-total-result">£{{(+item.cost_total+ +item.cost_extra_bonus) | formatFloat}}</span>
                </v-col>
              </v-row>
            </v-card>
            <!--/ body -->
          </v-card>
          <!--/ right panel work area -->

          <!-- timesheet form -->
          <v-app-bar
            ref="toolBarTimesheetForm"
            class="d-flex tool-bar__timesheet-form"
            color="white elevation-0"
            :bottom="fixed_panel"
            :fixed="fixed_panel"
            :class="{'tool-bar__timesheet-form-fixed': fixed_panel}"
            height="auto"
            :style="fixed_panel ? 'margin-bottom: 25px;' : ''"
          >
            <v-card
              color="grey lighten-4"
              style="width: 70%;"
              class="ml-1 mr-1 mt-0"
            >
                <v-card-title class="pt-1 pb-1">
                    <span class="summary_headline">Timesheet summary</span>
                    <v-spacer></v-spacer>
                    <v-btn v-on:click="scrollToCurrentLine()" small>
                      <span><v-icon color="indigo accent-3" left>mdi-arrow-collapse-up</v-icon>Scroll To</span>
                    </v-btn>
                    <v-btn v-on:click="fixed_panel = !fixed_panel" class="ml-1" small>
                      <span v-if="fixed_panel"><v-icon color="deep-orange darken-2" left>mdi-lock-outline</v-icon>Pinned</span>
                      <span v-if="!fixed_panel"><v-icon left>mdi-lock-open-variant-outline</v-icon>Pinned</span>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <!-- fill form from founded shift -->
                    <v-card
                      color="elevation-1"
                      class="yellow lighten-4 mb-3"
                      v-if="compatable_shift"
                    >
                      <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                          Scheduled Details:
                            <span :class="{'orange accent-4': compatable_shift.period_date != header2IsoDate(period_date)}">{{compatable_shift.period_date | headerDate}}</span>
                            &nbsp;
                            <span :class="{'orange accent-4': compatable_shift.restaurant_id != restaurant_id}">{{getAreaLabel(compatable_shift.restaurant_id)}}</span>
                            &nbsp;
                            <span :class="{'orange accent-4': compatable_shift.start_time != start_time + ':00'}">{{compatable_shift.start_time | formatTime}}</span>
                            &nbsp;-&nbsp;
                            <span :class="{'orange accent-4': compatable_shift.finish_time != finish_time + ':00'}">{{compatable_shift.finish_time | formatTime}}</span>,
                            &nbsp;bonus:&nbsp;
                            <span :class="{'orange accent-4': compatable_shift.cost_bonus != cost_bonus}">+£{{compatable_shift.cost_bonus}}</span>,
                            &nbsp;Fuel bonus:&nbsp;
                            <span :class="{'orange accent-4': compatable_shift.const_fuel_bonus != const_fuel_bonus}">+£{{compatable_shift.const_fuel_bonus}}</span>,
                            &nbsp;hidden bonus:&nbsp;
                            <span :class="{'orange accent-4': compatable_shift.cost_extra_bonus != cost_extra_bonus}">+£{{compatable_shift.cost_extra_bonus}}</span>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-btn @click="onImportScheduledDetails" :disabled="timeSheetEditDisabled">
                            <v-icon>mdi-calendar-import</v-icon>&nbsp;Import Scheduled Details
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                    <!-- / fill form from founded shift -->
                    <!-- view mode, - status == STATUS_APPROVED -->
                    <!--/ view mode, - status == STATUS_APPROVED -->
                    <!-- edit mode -->
                    <v-form ref="form">
                      <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                              prepend-icon="mdi-map-marker"
                              label="Restaurant"
                              item-text="name"
                              item-value="id"
                              v-model="restaurant_id"
                              :disabled="timeSheetEditDisabled"
                              :items="restaurant_list"
                              :error-messages="selectAreaErrors"
                              @blur="$v.restaurant_id.$touch()"
                              required
                              dense
                              hide-details
                          >
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row dense>
                          <v-col cols="12" sm="6" md="6">
                              <v-menu
                                v-model="timesheet_date_picker"
                                transition="scale-transition"
                                :close-on-content-click="false"
                                :nudge-width="200"
                                max-width="346px"
                                offset-y
                              >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                      v-on="on"
                                      clear-icon="mdi-close"
                                      prepend-icon="mdi-calendar"
                                      clearable
                                      outlined
                                      label="Date*"
                                      hint="22/11/2019"
                                      required
                                      v-model="period_date"
                                      :disabled="timeSheetEditDisabled"
                                      :error-messages="periodDateErrors"
                                      @input="$v.period_date.$touch()"
                                      @blur="$v.period_date.$touch()"
                                      autocomplete="off"
                                      dense
                                  ></v-text-field>
                                </template>

                                <v-card max-width="346px">
                                  <v-date-picker
                                    v-model="period_date_selected"
                                    scrollable
                                    actions
                                    full-width
                                    first-day-of-week="1"
                                    :title-date-format="getPeriodDateText"
                                    v-on:click:date="periodDateSelect"
                                    :max="period_date_max"
                                  ></v-date-picker>
                                </v-card>
                              </v-menu>
                          </v-col>
                          <v-col cols="12" sm="3" md="3">
                              <v-autocomplete
                                  class="hide-time-picker-indicator"
                                  type="time"
                                  :menu-props="{auto: true, overflowY: true}"
                                  clear-icon="mdi-close"
                                  prepend-icon="mdi-clock-outline"
                                  clearable
                                  outlined
                                  label="Start Time*"
                                  hint="Example: 08:00"
                                  required
                                  v-model="start_time"
                                  :disabled="timeSheetEditDisabled"
                                  :items="timeList"
                                  item-text="name"
                                  item-value="value"
                                  :error-messages="startTimeErrors"
                                  open-on-clear
                                  v-on:focus="onStartTimeFocused"
                                  v-on:input="onStartTimeChanged"
                                  v-on:blur="onStartTimeBlur"
                                  dense
                              >
                              </v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="3" md="3">
                              <v-autocomplete
                                  class="hide-time-picker-indicator"
                                  type="time"
                                  menu-props="auto, overflowY"
                                  clear-icon="mdi-close"
                                  prepend-icon="mdi-clock-outline"
                                  clearable
                                  outlined
                                  label="Finish Time*"
                                  hint="Example: 18:30"
                                  required
                                  v-model="finish_time"
                                  :disabled="timeSheetEditDisabled"
                                  :items="timeList"
                                  item-text="name"
                                  item-value="value"
                                  :error-messages="finishTimeErrors"
                                  @input="$v.finish_time.$touch()"
                                  open-on-clear
                                  v-on:focus="onFinishTimeFocused"
                                  v-on:input="onFinishTimeChanged"
                                  v-on:blur="onFinishTimeBlur"
                                  dense
                              >
                              </v-autocomplete>
                          </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            type="number"
                            label="Add Driver Bonus"
                            v-model="cost_bonus"
                            :disabled="timeSheetEditDisabled"
                            required
                            outlined
                            dense
                          >
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            type="number"
                              prepend-icon="mdi-wallet-giftcard"
                              label="Cancellation fee/bonus"
                              v-model="cost_extra_bonus"
                              :disabled="timeSheetEditDisabled"
                              required
                              outlined
                              dense
                            >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-row>
                            <v-col cols="xl-2">
                            <v-text-field
                              type="number"
                              label="0-3"
                              v-model="fuel_bonus_0"
                              @input="calculateBonus"
                              :disabled="timeSheetEditDisabled"
                              min="0"
                              required
                              outlined
                              dense
                            ></v-text-field>
                        </v-col>
                            <v-col cols="xl-2">
                                <v-text-field
                                  type="number"
                                  label="3-6"
                                  v-model="fuel_bonus_3"
                                  @input="calculateBonus"
                                  :disabled="timeSheetEditDisabled"
                                  min="0"
                                  required
                                  outlined
                                  dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="xl-2">
                                <v-text-field
                                  type="number"
                                  label="6+"
                                  v-model="fuel_bonus_6"
                                  @input="calculateBonus"
                                  :disabled="timeSheetEditDisabled"
                                  min="0"
                                  required
                                  outlined
                                  dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="1.5">
                                <v-text-field
                                  type="number"
                                  prepend-icon="mdi-gas-station"
                                  label="Fuel Bonus"
                                  v-model="const_fuel_bonus"
                                  :value="const_fuel_bonus"
                                  readonly
                                  required
                                  outlined
                                  dense
                                ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-textarea
                                outlined
                                label="Shift comment"
                                v-model="comment"
                                :disabled="timeSheetEditDisabled"
                                hide-details
                                rows="2"
                                dense
                            ></v-textarea>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                            <v-textarea
                                outlined
                                label="Driver's comment"
                                v-model="driver_comment"
                                :disabled="timeSheetEditDisabled"
                                hide-details
                                rows="2"
                                dense
                            ></v-textarea>
                        </v-col>

                      </v-row>
                    </v-form>
                    <!--/ edit mode -->
              </v-card-text>
            </v-card>
            <div
              class="d-flex flex-column"
              style="width: 30%"
            >
              <v-card
                color="grey lighten-4"
                class="mt-0 ml-0 mb-0 mr-0"
                tile
              >
                <v-col>
                  <v-row>
                    <v-col cols="12" sm="12" md="6" lg="4" class="pa-1">
                      <v-btn
                          depressed
                          class="mr-4 green"
                          :disabled="this.$v.$invalid || localLoading || select_time_sheet && select_time_sheet.status == STATUS_APPROVED"
                          :loading="localLoading"
                          @click="onApproveSelected"
                          width="100%">
                        <v-icon>mdi-check-outline</v-icon>&nbsp;Approve
                      </v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" lg="4" class="pa-1">
                      <v-btn
                          depressed
                          class="mr-4 red darken-4"
                          :disabled="this.$v.$invalid || localLoading || select_time_sheet && select_time_sheet.status == STATUS_DISCARDED"
                          :loading="localLoading"
                          @click="onDiscardSelected"
                          width="100%">
                        <v-icon>mdi-delete-outline</v-icon>&nbsp;Discard
                      </v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" lg="4" class="pa-1">
                      <v-btn
                          depressed
                          class="mr-4 red darken-4"
                          :disabled="localLoading || !select_time_sheet || select_time_sheet.id <= 0"
                          :loading="localLoading"
                          @click="onRemoveSelected"
                          width="100%">
                        <v-icon>mdi-close-circle</v-icon>&nbsp;Remove
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-if="select_time_sheet && (select_time_sheet.status == STATUS_APPROVED || select_time_sheet.status_progress == STATUS_PROGRESS_TIME_APPROVED)">
                    <v-col cols="12" sm="12" md="12" lg="6" class="pa-1">
                      <v-btn
                          depressed
                          class="mr-4 deep-orange"
                          :disabled="this.$v.$invalid || localLoading"
                          :loading="localLoading"
                          @click="onUnapproveTimeSelected"
                          width="100%">
                        <v-icon>mdi-timer-off</v-icon>&nbsp;Unapprove Time
                      </v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="6" class="pa-1">
                      <v-btn
                          depressed
                          class="mr-4 orange"
                          :disabled="this.$v.$invalid || localLoading || select_time_sheet.status_progress == STATUS_PROGRESS_TIME_APPROVED"
                          :loading="localLoading"
                          @click="onUnapprovePaySelected"
                          width="100%">
                        <v-icon>mdi-steering-off</v-icon>&nbsp;Unapprove Pay
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-card>
              <v-card
                color="grey lighten-4"
                style="margin: 7px 0px 0px 0px;"
                tile
              >
                <v-col>
                  <GmapMap
                    ref="mapRef"
                    :options="{
                      zoomControl: true,
                      mapTypeControl: false,
                      scaleControl: true,
                      streetViewControl: false,
                      rotateControl: false,
                      fullscreenControl: true,
                      disableDefaultUi: false
                    }"
                    :center="map_center"
                    :zoom="map_zoom"
                    map-type-id="terrain"
                    style="width: 100%; height: 320px"
                  >
                    <GmapMarker v-if="map_marker_start" :position="map_marker_start" :title="`Started at: ${moment(select_time_sheet.driver_start_time ? select_time_sheet.driver_start_time : select_time_sheet.start_time, 'HH:mm').format('HH:mm')}`" :icon="{ url: ICON_FINISH, size: {width: 45, height: 45, f: 'px', b: 'px'}, scaledSize: {width: 45, height: 45, f: 'px', b: 'px'}}" />
                    <GmapMarker v-if="map_marker_finish" :position="map_marker_finish" :title="`Finished at: ${moment(select_time_sheet.driver_finish_time ? select_time_sheet.driver_finish_time : select_time_sheet.finish_time, 'HH:mm').format('HH:mm')}`" :icon="{ url: ICON_START, size: {width: 45, height: 45, f: 'px', b: 'px'}, scaledSize: {width: 45, height: 45, f: 'px', b: 'px'}}" />
                    <GmapMarker v-if="map_marker_resturant" :position="map_marker_resturant" :title="`${getRestaurantNameByID(select_time_sheet.restaurant_id)}`" />
                    <GmapMarker v-if="map_marker_live" :position="map_marker_live" :title="`Driver: ${select_time_sheet.driver_id}`" :icon="{ url: ICON_LIVE, size: { width: 45, height: 45, f: 'px', b: 'px' }, scaledSize: { width: 45, height: 45, f: 'px', b: 'px' }  }" />
                  </GmapMap>
                </v-col>
              </v-card>
            </div>
          </v-app-bar>
          <!--/ timesheet form -->
        </v-card>
      </div>
      <!--/ body -->
      <!-- tool bar bottom -->
      <v-card
          color="grey lighten-4"
          flat
          style="margin-bottom: -5px;"
          tile
      >
        <v-app-bar
          fixed
          bottom
          height="36px"
          color="elevation-1 tool-bar__totals-panel">
          <v-spacer></v-spacer>
          <div>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.approved}}</div>
              <div class="shift-total_label">Approved Timesheets</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.unapproved}}</div>
              <div class="shift-total_label">Unapproved Timesheets</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.free}}</div>
              <div class="shift-total_label">Free Timesheets</div>
            </v-btn>
          </div>
          <v-spacer></v-spacer>

          <div>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.total_timesheets}}</div>
              <div class="shift-total_label">Total Timesheets</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.filled_hours | formatHours}}</div>
              <div class="shift-total_label">Filled Hours</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">£{{totals.estimated_cost | formatFloat}}</div>
              <div class="shift-total_label">Est. Cost</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">£{{totals.expected_sales | formatFloat}}</div>
              <div class="shift-total_label">Expected Sales</div>
            </v-btn>
          </div>
        </v-app-bar>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment';
import Vue from 'vue';
import * as _ from 'lodash';
import { mapGetters } from 'vuex';
import { TYPE_AREA, TYPE_RESTAURANT } from '../../store/areas';
import { STATUS_DRAFT, DATE_RANGE_HELPERS,
         INTERVAL_DAY, INTERVAL_WEEK, INTERVAL_TWO_WEEK, INTERVAL_MONTH
       } from '../../store/shifts';
import { STATUS_PENDING, STATUS_DISCARDED, STATUS_APPROVED,
         STATUS_PROGRESS_IN_WORK, STATUS_PROGRESS_SUBMITED, STATUS_PROGRESS_NOT_SUBMITED,
          STATUS_PROGRESS_PAY_APPROVED, STATUS_PROGRESS_TIME_APPROVED, STATUS_PROGRESS_DISCARDED,
          STATUS_PROGRESS_DISCARDED_BY_DRIVER
       } from '../../store/timesheets';
import {validationMixin} from 'vuelidate';
import {required, /* maxLength, email, numeric*/} from 'vuelidate/lib/validators';
import {gmapApi} from 'vue2-google-maps'

import ICON_START from '../../assets/map_start.png';
import ICON_FINISH from '../../assets/map_finish.png';
import ICON_RESTAURANT from '../../assets/map_restaurant.png';
import ICON_LIVE from '../../assets/live.png';

const DEFAULT_MAP_CENTER = {lat:51.4, lng:0}; // default London

const STATUS_SELECT_ACTIVE = 10;
const STATUS_SELECT_NOT_SUBMITED = 20;
const STATUS_SELECT_ALL = 50;
const MODEL_TYPE_SHIFTS = 10;
const CANCELLED = 40;

export default {
  name: "Timesheet",
  mixins: [validationMixin],
  validations: {
      restaurant_id: { required },
      period_date: { required,/* maxLength: maxLength(10)*/ },
      start_time: { required,/* maxLength: maxLength(10)*/ },
      finish_time: { required },
      comment: { },
      driver_comment: { }
  },
  data: () => ({
    // panels
    scroll_panel_height: window.innerHeight - 122,
    // const list for template
    TYPE_AREA: TYPE_AREA,
    TYPE_RESTAURANT: TYPE_RESTAURANT,
    // status consts:
    STATUS_PENDING: STATUS_PENDING,
    STATUS_DISCARDED: STATUS_DISCARDED,
    STATUS_APPROVED: STATUS_APPROVED,
    // status_progress consts:
    STATUS_PROGRESS_IN_WORK: STATUS_PROGRESS_IN_WORK,
    STATUS_PROGRESS_SUBMITED: STATUS_PROGRESS_SUBMITED,
    STATUS_PROGRESS_NOT_SUBMITED: STATUS_PROGRESS_NOT_SUBMITED,
    STATUS_PROGRESS_PAY_APPROVED: STATUS_PROGRESS_PAY_APPROVED,
    STATUS_PROGRESS_TIME_APPROVED: STATUS_PROGRESS_TIME_APPROVED,
    STATUS_PROGRESS_DISCARDED: STATUS_PROGRESS_DISCARDED,
    STATUS_PROGRESS_DISCARDED_BY_DRIVER: STATUS_PROGRESS_DISCARDED_BY_DRIVER,
    ICON_START: ICON_START,
    ICON_FINISH: ICON_FINISH,
    ICON_RESTAURANT: ICON_RESTAURANT,
    ICON_LIVE: ICON_LIVE,
    interval_list: [
      { id: INTERVAL_DAY, name: 'Day', $isDisabled: true },
      { id: INTERVAL_WEEK, name: 'Week' },
      { id: INTERVAL_TWO_WEEK, name: '2-Week' },
      { id: INTERVAL_MONTH, name: 'Month' },
    ],
    status_list: [
      { id: STATUS_SELECT_ACTIVE, name: 'Active' }, // submited, - need
      { id: STATUS_SELECT_NOT_SUBMITED, name: 'Pending' }, // not submited
      { id: STATUS_SELECT_ALL, name: 'All' },
    ],
    localLoading: false,
    approvePeriodLoading: false,
    xlsExportLoading: false,
    date_range_selected: null,
    period_date_selected: null,
    period_date_max: moment().add(1, 'days').format('YYYY-MM-DD'),
    timesheet_selected: null,
    menu_date_picker: false,
    timesheet_date_picker: false,
    location_selected: void 0,
    interval_selected_id: INTERVAL_WEEK, // default one week
    status_selected_id: STATUS_SELECT_ACTIVE, // default show all
    selected_driver: void 0,
    search_driver: '',
    driver_list_calc: {}, // cached property
    select_time_sheet: void 0,
    select_time_sheet_index: 0,
    compatable_shift: void 0,
    invoice_comission_default: void 0,
    invoice_comission: void 0,
    // form fields:
    restaurant_id: void 0,
    period_date: void 0,
    start_time: void 0,
    finish_time: void 0,
    comment: void 0,
    driver_comment: void 0,
    cost_bonus: 0,
    const_fuel_bonus: 0,
    cost_extra_bonus: 0,
    map_center: DEFAULT_MAP_CENTER, // default: London
    map_zoom: 8,
    map_marker_start: void 0,
    map_marker_finish: void 0,
    map_marker_resturant: void 0,
    map_marker_live : void 0,
    totals: {
      total_timesheets: 0,
      filled_hours: 0,
      estimated_cost: 0,
      expected_sales: 0,
      approved: 0,
      unapproved: 0,
      free: 0,
    },
    fixed_panel: true,
    tool_bar_timesheet_form_height: 396,
    start_time_was_clean: false,
    finish_time_was_clean: false,
    fuel_bonus_0: 0,
    fuel_bonus_3: 0,
    fuel_bonus_6: 0,
    fuel_bonus_0_default: 0,
    fuel_bonus_3_default: 0,
    fuel_bonus_6_default: 0,
    cancel_fee_changed: false,
  }),
  computed: {
    ...mapGetters({
      timeList: 'timeList',
      locations_list: 'locations',
      area_list: 'areas',
      restaurant_list: 'restaurants',
      driver_list: 'drivers',
      shift_list: 'shifts',
      timesheet_list: 'timesheets',
      options: 'options',
    }),
    //Other computed properties
    restaurantListSearched() {
      if (!this.$data.location_selected) {
        return this.restaurant_list;
      }

      if (this.$data.location_selected.type == TYPE_AREA) {
        // filter by list of restaurants
        return _.filter(this.restaurant_list, p => p.area_id == this.$data.location_selected.id);
      } else if (this.$data.location_selected.type == TYPE_RESTAURANT) {
        // filter by one restaurant
        let restaurant = _.find(this.restaurant_list, p => p.id == this.$data.location_selected.id)
        if (restaurant) {
          return [restaurant];
        }
        return [];
      }

      return this.restaurant_list;
    },
    driverListSearched() {
      let driver_list = _.map(this.driver_list, p => p); // copy array, - be modifed

      // filter by search
      if (this.$data.search_driver) {
        driver_list = _.filter(driver_list, p => p.full_name.toLowerCase().indexOf(this.$data.search_driver) !== -1)
      }

      // filter by selected area or selected restaurant area
      if (this.$data.location_selected) {
        // filter by aread ids
        let area_ids = _.map(this.restaurantListSearched, p => +p.area_id);
        driver_list = _.filter(driver_list, driver => {
          let driver_area_ids = _.map(driver.area_ids, p => p.area_id);
          return ( _.intersection(area_ids, driver_area_ids).length > 0)
        });

        // filter by restaurants, check if driver assigned to other restaurant
        if (this.$data.location_selected.type == TYPE_RESTAURANT) {
          driver_list = _.filter(driver_list, driver => {
            if (driver.restaurant_ids.length == 0) {
              return true; // driver not assigned to restaurant
            }

            let driver_restaurant_ids = _.map(driver.restaurant_ids, p => p.restaurant_id);
            return driver_restaurant_ids.indexOf(this.$data.location_selected.id) !== -1;
          });
        }
      }

      // add free shifts filter
      if(driver_list.length == 0 || (driver_list.length > 0 && driver_list[0].id !== null)) {
        let all_drivers = {
            id: -1,
            full_name: 'All drivers [' + driver_list.length + ']',
        };

        let free_driver = {
            id: -2,
            full_name: "Open shift",
        };

        driver_list.unshift(free_driver);
        driver_list.unshift(all_drivers);
      }

      return driver_list;
    },
    timesheetListSearched() {
      /**
       * if `shift` has no related `timesheet`
       *  then it not exists:
       *  `timesheet`.`status` == STATUS_PENDING and `timesheet`.`status_progress` == STATUS_PROGRESS_NOT_SUBMITED
       *
       * Let's create not exists `timesheet`'s fromn `shift`'s
       **/
      let shift_list = this.shift_list;

      // filter draft (if edited)
      shift_list = _.filter(shift_list, p => p.status != STATUS_DRAFT);

      let result = [];

      // push exists shifts
      if (this.$data.status_selected_id == STATUS_SELECT_ACTIVE || this.$data.status_selected_id == STATUS_SELECT_ALL) {
        for (let i = 0; i < this.timesheet_list.length; i++) {
          result.push(this.timesheet_list[i]);
        }
      }

      if (this.$data.status_selected_id == STATUS_SELECT_NOT_SUBMITED || this.$data.status_selected_id == STATUS_SELECT_ALL) {
        // push virtual shifts (not exists)
        for (let i = 0; i < shift_list.length; i++) {
          // if shift not exists then create new with status
          let timesheet_item = _.find(this.timesheet_list, (p) => +p.shift_id == +shift_list[i].id);

          if (_.isEmpty(timesheet_item)) {
            // `timesheet`.`status` == STATUS_PENDING `timesheet`.`status_progress` == STATUS_PROGRESS_NOT_SUBMITED
            let pendig_timeshift = {
              id: -i, //! negative
              shift_id: shift_list[i].id,
              restaurant_id: shift_list[i].restaurant_id,
              driver_id: shift_list[i].driver_id,
              status: STATUS_PENDING,
              status_progress: STATUS_PROGRESS_NOT_SUBMITED,
              period_date: shift_list[i].period_date,
              start_time: shift_list[i].start_time,
              finish_time: shift_list[i].finish_time,
              meal_time: 0,
              rest_time: 0,
              cost_per_hour: shift_list[i].cost_per_hour,
              cost_bonus: shift_list[i].cost_bonus,
              const_fuel_bonus: shift_list[i].const_fuel_bonus,
              cost_extra_bonus: shift_list[i].cost_extra_bonus,
              cost_total: shift_list[i].cost_total, //! BUG need recalculate
              // map_start_lat: null,
              // map_start_lng: null,
              // map_finish_lat: null,
              // map_finish_lng: null,
              comment: shift_list[i].comment,
              // driver_comment: null,
              // created_at: null,
              // updated_at: null,
              fuel_bonus_0: shift_list[i].fuel_bonus_0,
              fuel_bonus_3: shift_list[i].fuel_bonus_3,
              fuel_bonus_6: shift_list[i].fuel_bonus_6,
            }

            result.push(pendig_timeshift);
          }
        }
      }

      // recalc `cost_total` (not rounded), to fix decimals
      for (let i = 0; i < result.length; i++) {
        let cost_total = +result[i].cost_per_hour * this.getShiftHours(result[i]);

        // add bonus to cost total
        if (result[i].cost_bonus) {
          cost_total = parseFloat(cost_total) + +parseFloat(result[i].cost_bonus);
        }

        // add fuel bonus to cost total
        if (result[i].const_fuel_bonus) {
          cost_total = parseFloat(cost_total) + +parseFloat(result[i].const_fuel_bonus);
        }

        result[i].cost_total = cost_total;
      }

      //-- apply result filters:
      //-- filter by `location_selected`
      if (this.$data.location_selected !== void 0) {
        let restaurant_ids = _.map(this.restaurantListSearched, p => +p.id);
        result = _.filter(result, p => restaurant_ids.indexOf(+p.restaurant_id) !== -1);
      }

      result = _.orderBy(result, p => p.start_time);
      result = _.orderBy(result, p => p.period_date);

      return result;
    },
    timesheetListSearchedFilterDriver() {
      let shift_list = this.timesheetListSearched;

      //-- filter by `selected_driver`
      if (this.$data.selected_driver !== void 0) {
        shift_list = _.filter(shift_list, p => p.driver_id == this.$data.selected_driver.id);
      }

      return shift_list;
    },
    periodDateErrors () {
        const errors = [];
        if (!this.$v.period_date.$dirty) {
            return errors;
        }
        !this.$v.period_date.required && errors.push('Date is required.')
        !moment(this.$data.period_date, "DD/MM/YYYY").isValid() && errors.push('Date invalid format.')
        return errors
    },
    selectAreaErrors () {
      const errors = [];
      if (!this.$v.restaurant_id.$dirty) {
          return errors;
      }
      !this.$v.restaurant_id.required && errors.push('Area is required');
      return errors
    },
    startTimeErrors () {
        const errors = [];
        if (!this.$v.start_time.$dirty) {
            return errors;
        }
        !this.$v.start_time.required && errors.push('Start Time is required.')
        !moment(this.$data.start_time, "HH:mm").isValid() && errors.push('Start Time invalid format.')
        return errors
    },
    finishTimeErrors () {
        const errors = [];
        if (!this.$v.finish_time.$dirty) {
            return errors;
        }
        !this.$v.finish_time.required && errors.push('Start Time is required.')
        !moment(this.$data.finish_time, "HH:mm").isValid() && errors.push('Finish Time invalid format.')
        return errors
    },
    timeSheetEditDisabled() {
      if (!this.$data.select_time_sheet) {
        return true;
      }

      return this.$data.select_time_sheet.status == STATUS_APPROVED;
    },
    unapprovedTimesheets() {
      let unapproved_timesheets = _.filter(this.timesheetListSearchedFilterDriver, p => p.status == STATUS_PENDING && p.driver_id);
      return unapproved_timesheets.length;
    },
    statusColor() {
      switch(this.status_selected_id) {
        case STATUS_SELECT_ACTIVE:
          return 'green lighten-3';
        case STATUS_SELECT_ALL:
          return '';
        // case STATUS_SELECT_NOT_SUBMITED:
      }

      return 'primary lighten-3';
    },
    google: gmapApi,
  },
  watch: {
    period_date: function(period_date_new) {
      if (
           this.$data.period_date_selected != period_date_new
        && /\d\d\/\d\d\/\d\d\d\d/.test(period_date_new) // check is date valid format
      ) {
        this.$data.period_date_selected = moment(period_date_new, "DD/MM/YYYY").format('YYYY-MM-DD');
      }
    },
    timesheetListSearched: function(timesheed_list_new) {
      if (timesheed_list_new.length == 0) {
        return; // exit
      }

      let shift_total_hours_tmp = []; // cached array
      for (let j = 0; j < timesheed_list_new.length; j++) {
        shift_total_hours_tmp[j] = this.getShiftHours(timesheed_list_new[j]);
      }

      // calc driver totals
      let driver_list = this.driverListSearched;
      // this.$data.driver_list_calc = {};
      for (let i = 0; i < driver_list.length; i++) {
        let driver_calc_item = {
          cost: 0,
          hours: 0,
          timesheets: 0,
        };

        for (let j = 0; j < timesheed_list_new.length; j++) {
          if (timesheed_list_new[j].driver_id == driver_list[i].id || (timesheed_list_new[j].driver_id == null && driver_list[i].id == -2)) {
            driver_calc_item.cost = +driver_calc_item.cost + +timesheed_list_new[j].cost_total + +timesheed_list_new[j].cost_extra_bonus;
            //! cost_bonus and const_fuel_bonus already attached into cost_total
            // if (timesheed_list_new[j].cost_bonus) {
            //   driver_calc_item.cost = driver_calc_item.cost + +timesheed_list_new[j].cost_bonus;
            // }
            // if (timesheed_list_new[j].const_fuel_bonus) {
            //   driver_calc_item.cost = driver_calc_item.cost + +timesheed_list_new[j].const_fuel_bonus;
            // }
            driver_calc_item.hours = +driver_calc_item.hours + shift_total_hours_tmp[j];
            driver_calc_item.timesheets = driver_calc_item.timesheets + 1;
          }
        }

        this.$data.driver_list_calc[driver_list[i].id] = driver_calc_item;
      }
    },
    timesheetListSearchedFilterDriver: function(timesheed_list_new) {
      // calc totals
      this.$data.totals.total_timesheets = timesheed_list_new.length;
      this.$data.totals.filled_hours = 0;
      this.$data.totals.estimated_cost = 0;
      this.$data.totals.expected_sales = 0;
      this.$data.totals.approved = 0;
      this.$data.totals.unapproved = 0;
      this.$data.totals.free = 0;

      if (timesheed_list_new.length == 0) {
        return; // exit
      }

      if (this.$data.selected_driver !== void 0) { // do not refresh on select driver
        let driver_id = this.$data.selected_driver.id;
        timesheed_list_new = _.filter(timesheed_list_new, p => p.driver_id == driver_id);
      }

      let shift_total_hours_tmp = []; // cached array
      for (let j = 0; j < timesheed_list_new.length; j++) {
        shift_total_hours_tmp[j] = this.getShiftHours(timesheed_list_new[j]);
        this.$data.totals.filled_hours += shift_total_hours_tmp[j];
        if (timesheed_list_new[j].status == STATUS_APPROVED) {
          this.$data.totals.estimated_cost += +timesheed_list_new[j].cost_total + +timesheed_list_new[j].cost_extra_bonus;
          this.$data.totals.approved += 1;
        } else { // STATUS_NEW
          this.$data.totals.unapproved += 1;
        }
        if (+timesheed_list_new[j].driver_id == 0) { // !timesheed_list_new[j].driver_id
          this.$data.totals.free += 1;
        }
        // STATUS_PUBLICATED || STATUS_NEW
        this.$data.totals.expected_sales += +timesheed_list_new[j].cost_total + +timesheed_list_new[j].cost_extra_bonus;
      }

      // refresh selected state
      this.onSelectTimeSheet(this.$data.select_time_sheet_index);
    },
    location_selected: function(val) {
      this.invoice_comission = this.invoice_comission_default;
      if (val && val.type == TYPE_RESTAURANT) {
        let restaurant = _.find(this.restaurant_list, p => +p.id == +val.id)
        if (restaurant && restaurant.invoice_comission) {
          this.invoice_comission = restaurant.invoice_comission;
        }
      }
    },
    cost_extra_bonus: function(old_value) {
      this.cancel_fee_changed = false;
      if (this.select_time_sheet.cost_extra_bonus !== Number(old_value))
        this.cancel_fee_changed = true; //bonus was edited
      }
  },
  mounted() {
    // scroll panel height
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });

    // moment.locale(['ru', 'en']);
    // aync load data
    Promise.all([
      this.$store.dispatch('fetchLocations'),
      this.$store.dispatch('fetchDrivers'),
      this.$store.dispatch('fetchOptions'), // map_center
      // this.$store.dispatch('fetchRestaurants'), //? double loadin
      // this.$store.dispatch('fetchAreas') //? double loadin
    ]).then(() => {
      // setup map default center
      let option = _.find(this.options, p => p.okey == 'map_center_default');
      //Get fuel Bonus for number of deliveried made
      let fuel_bonus_0_val = _.find(this.options, p => p.okey == 'fuel_bonus_0');
      let fuel_bonus_3_val = _.find(this.options, p => p.okey == 'fuel_bonus_3');
      let fuel_bonus_6_val = _.find(this.options, p => p.okey == 'fuel_bonus_6');


      if (option) {
        let map_options = JSON.parse(option.ovalue);

        this.map_center = {
            lat: map_options.lat,
            lng: map_options.lng
        };
        this.map_zoom = map_options.map_zoom;
      }

      // setup default comission
      let invoice_comission_default = _.find(this.options, p => p.okey == 'restaurants_standard_invoice_comission');
      if (invoice_comission_default && invoice_comission_default.ovalue) {
          this.invoice_comission_default = invoice_comission_default.ovalue;
      }
      if (fuel_bonus_0_val && fuel_bonus_0_val.ovalue) {
          this.fuel_bonus_0_default = fuel_bonus_0_val.ovalue;
      }
      if (fuel_bonus_3_val && fuel_bonus_3_val.ovalue) {
          this.fuel_bonus_3_default = fuel_bonus_3_val.ovalue;
      }
      if (fuel_bonus_6_val && fuel_bonus_6_val.ovalue) {
          this.fuel_bonus_6_default = fuel_bonus_6_val.ovalue;
      }
      let current_date = moment();
      // this.$data.interval_selected_id = this.$data.interval_list[1].id; // 1 - one week
      this.$data.date_range_selected = [current_date.startOf('isoWeek').format('YYYY-MM-DD'), null];

      this.dateRangeSelect().then(() => {
        this.onSelectTimeSheet(0);
      });
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.scroll_panel_height = window.innerHeight - 122;
    },
    dateRangeSelect: async function() {
      this.$data.date_range_selected = this.dayToRange(this.$data.date_range_selected[0], this.$data.interval_selected_id);

      // fetch shifts from server
      await Promise.all([
        this.$store.dispatch('fetchShifts', {
          period_date_from: this.$data.date_range_selected[0],
          period_date_to: this.$data.date_range_selected[1],
          // with_timesheet: '1'
          filter_draft: '1',
        }),
        this.$store.dispatch('fetchTimesheets', {
          period_date_from: this.$data.date_range_selected[0],
          period_date_to: this.$data.date_range_selected[1]
        })
      ]);
    },
    periodDateSelect: function() {
      this.$data.period_date = moment(this.$data.period_date_selected, 'YYYY-MM-DD').format("DD/MM/YYYY");
      this.$data.timesheet_date_picker = false; // hide calendar
    },
    getDriverFullName: function(driver_id) {
      // fill relation data: driver
      let driver = _.find(this.driver_list, p => p.id == driver_id);

      if (!driver) {
        return 'Open shift';
      }

      return driver.full_name;
    },
    onSelectInterval: function() {
      if (this.$data.interval_selected_id == INTERVAL_WEEK || this.$data.interval_selected_id == INTERVAL_TWO_WEEK || this.$data.interval_selected_id == INTERVAL_MONTH) { // reset to the start of week, if changed from day
        let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
        this.$data.date_range_selected = [date_to_shift.startOf('isoWeek').format("YYYY-MM-DD"), null];
      }

      if (this.$data.interval_selected_id == INTERVAL_DAY) { // reset to the current day, if changed from week
        let current_day = moment();
        // let date_to_shift_start = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
        // let date_to_shift_end = moment(this.$data.date_range_selected[1], "YYYY-MM-DD");
        // if (date_to_shift_start < current_day && current_day < date_to_shift_end) {
          this.$data.date_range_selected = [current_day.format("YYYY-MM-DD"), null];
        // } else {
        //  this.$data.date_range_selected = [date_to_shift_start.format("YYYY-MM-DD"), null];
        //}
      }

      Vue.nextTick(() => {
        this.dateRangeSelect().then(() => {
          this.onSelectTimeSheet(0);
        });
      });
    },
    onPreviosRange: function() {
      let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      switch(this.$data.interval_selected_id) {
        case INTERVAL_DAY:
          date_to_shift.subtract(1, 'day');
          break;
        case INTERVAL_WEEK:
          date_to_shift.subtract(1, 'weeks');
          break;
        case INTERVAL_TWO_WEEK:
          date_to_shift.subtract(2, 'weeks');
          break;
        case INTERVAL_MONTH:
          date_to_shift.subtract(1, 'months');
          break;
      }

      // this.$data.date_range_selected
      this.$data.date_range_selected = [date_to_shift.format("YYYY-MM-DD"), null];
      this.dateRangeSelect().then(() => {
        this.onSelectTimeSheet(0);
      });
    },
    onNextRange: function() {
      let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      switch(this.$data.interval_selected_id) {
        case INTERVAL_DAY:
          date_to_shift.add(1, 'days');
          break;
        case INTERVAL_WEEK:
          date_to_shift.add(1, 'weeks');
          break;
        case INTERVAL_TWO_WEEK:
          date_to_shift.add(2, 'weeks');
          break;
        case INTERVAL_MONTH:
          date_to_shift.add(1, 'months');
          break;
      }

      // this.$data.date_range_selected
      this.$data.date_range_selected = [date_to_shift.format("YYYY-MM-DD"), null];
      this.dateRangeSelect().then(() => {
        this.onSelectTimeSheet(0);
      });
    },
    onChangeDriver: function(driver) {
      if(driver.id == -1) { // all drivers
        Vue.nextTick(() => {
          this.$data.selected_driver = void 0;
        });
      } else {
        Vue.nextTick(() => {
          if (this.$data.selected_driver && this.$data.selected_driver.id == driver.id) { // self clicked deselect
            this.$data.selected_driver = void 0;
            return; // exit
          }

          this.$data.selected_driver = driver;
        });
      }
    },
    onSelectTimeSheet: function(index) {
      if (!this.timesheetListSearchedFilterDriver[index]) {
        return; // exit if no items
      }

      this.$data.select_time_sheet = this.timesheetListSearchedFilterDriver[index];
      this.$data.select_time_sheet_index = index;
      const driver_id = this.$data.select_time_sheet.driver_id;
      if (this.$data.select_time_sheet && this.$data.select_time_sheet.status_progress === STATUS_PROGRESS_IN_WORK) {
        this.$store.dispatch('fetchDriverLocation', String(driver_id));
      }      

      // clear form data
      this.$data.restaurant_id = void 0;
      this.$data.period_date = void 0;
      this.$data.start_time = void 0;
      this.$data.finish_time = void 0;
      this.$data.comment = void 0;
      this.$data.driver_comment = void 0;
      this.$data.cost_bonus = 0;
      this.$data.const_fuel_bonus = 0;
      this.$data.cost_extra_bonus = 0;
      this.$data.fuel_bonus_0 = 0;
      this.$data.fuel_bonus_3 = 0;
      this.$data.fuel_bonus_6 = 0;

      // reset validation
      this.$v.$reset();

      // fill form data
      if (this.$data.select_time_sheet.status_progress != STATUS_PROGRESS_NOT_SUBMITED) {
        this.$data.restaurant_id = +this.$data.select_time_sheet.restaurant_id;
        this.$data.period_date = moment(this.$data.select_time_sheet.period_date, "YYYY-MM-DD").format('DD/MM/YYYY');

        // round 07 down to 00 minutes, 08 up to 15 minutes
        this.$data.start_time = this.timeToApproximation(this.$data.select_time_sheet.start_time);
        this.$data.finish_time = this.timeToApproximation(this.$data.select_time_sheet.finish_time);

        this.$data.comment = this.$data.select_time_sheet.comment;
        this.$data.driver_comment = this.$data.select_time_sheet.driver_comment;
        this.$data.cost_bonus = +this.$data.select_time_sheet.cost_bonus;
        this.$data.const_fuel_bonus = +this.$data.select_time_sheet.const_fuel_bonus;
        this.$data.cost_extra_bonus = +this.$data.select_time_sheet.cost_extra_bonus;
        this.$data.fuel_bonus_0 = +this.$data.select_time_sheet.fuel_bonus_0;
        this.$data.fuel_bonus_3 = +this.$data.select_time_sheet.fuel_bonus_3;
        this.$data.fuel_bonus_6 = +this.$data.select_time_sheet.fuel_bonus_6;
      }

      // find shift for this timesheet
      this.$data.compatable_shift = _.find(this.shift_list, (p) => +p.id == this.$data.select_time_sheet.shift_id);

      if (_.isEmpty(this.$data.comment)
        && this.$data.compatable_shift
        && this.$data.select_time_sheet.status_progress == STATUS_PROGRESS_NOT_SUBMITED
      ) {
        this.$data.comment = this.$data.compatable_shift.comment;
      }

      // paste markers on google map
      var latlngList = [];

      this.$data.map_marker_start = void 0;
      if (this.$data.select_time_sheet.map_start_lat && this.$data.select_time_sheet.map_start_lng) {
        this.$data.map_marker_start = this.google && new this.google.maps.LatLng(
          this.$data.select_time_sheet.map_start_lat,
          this.$data.select_time_sheet.map_start_lng
        );

        latlngList.push(this.$data.map_marker_start);
      }

      this.$data.map_marker_finish = void 0;
      if (this.$data.select_time_sheet.map_finish_lat && this.$data.select_time_sheet.map_finish_lng) {
        this.$data.map_marker_finish = this.google && new this.google.maps.LatLng(
          this.$data.select_time_sheet.map_finish_lat,
          this.$data.select_time_sheet.map_finish_lng
        );

        latlngList.push(this.$data.map_marker_finish);
      }

      // paste restaurant marker on map
      this.$data.map_marker_resturant = void 0;
      let resturant = _.find(this.restaurant_list, p => +this.$data.select_time_sheet.restaurant_id == +p.id);

      if (resturant && resturant.map_latitude && resturant.map_longitude) {
        this.$data.map_marker_resturant = this.google && new this.google.maps.LatLng(
          resturant.map_latitude,
          resturant.map_longitude
        );
        latlngList.push(this.$data.map_marker_resturant);
      }

      if (this.$data.select_time_sheet && this.$data.select_time_sheet.status_progress === STATUS_PROGRESS_IN_WORK) {
        const locations = this.$store.getters['driverLocations'];
        const newLocation = locations ? locations[driver_id] : null;
        
        if (this.google && newLocation && newLocation.latitude && newLocation.longitude) {
          this.$data.map_marker_live = this.google && new this.google.maps.LatLng(
            newLocation.latitude,
            newLocation.longitude
          );
          latlngList.push(this.$data.map_marker_live);
        }
      } else {
        this.$data.map_marker_live = null;
      }
      // change center of map
      if (_.isEmpty(latlngList)) { // no markers
        // setup map default center
        let option = _.find(this.options, p => p.okey == 'map_center_default');
        let map_options = JSON.parse(option.ovalue);

        if (map_options) {
          this.map_center = {
            lat: map_options.lat,
            lng: map_options.lng
          };
          this.map_zoom = map_options.map_zoom;
        }
      } else {
        var bounds = this.google && new this.google.maps.LatLngBounds();
        _.each(latlngList, (n) => {
            bounds.extend(n);
        });

        this.$refs.mapRef.$mapPromise.then((map) => {
          map.setCenter(bounds.getCenter()); //or use custom center
          map.fitBounds(bounds);

          // fix zoom
          if (latlngList.length == 1) {
            map.setZoom(map.getZoom() - 1);
            if(map.getZoom() > 15) {
                map.setZoom(15);
            }
          }
        });
      }

      // add list offset for fixed panel
      this.$nextTick(() => {
        this.$data.tool_bar_timesheet_form_height = this.$refs.toolBarTimesheetForm.$el.clientHeight;
      })
    },
    onImportScheduledDetails: function() {
      if (!this.$data.compatable_shift) {
        return;
      }

      this.$data.restaurant_id = +this.$data.compatable_shift.restaurant_id;
      this.$data.period_date = moment(this.$data.compatable_shift.period_date, "YYYY-MM-DD").format('DD/MM/YYYY');
      this.$data.start_time = moment(this.$data.compatable_shift.start_time, "HH:mm").format('HH:mm');
      this.$data.finish_time = moment(this.$data.compatable_shift.finish_time, "HH:mm").format('HH:mm');
      this.$data.cost_bonus = this.$data.compatable_shift.cost_bonus;
      this.$data.const_fuel_bonus = this.$data.compatable_shift.const_fuel_bonus;
      this.$data.cost_extra_bonus = this.$data.compatable_shift.cost_extra_bonus;
      this.$data.fuel_bonus_0 = this.$data.compatable_shift.fuel_bonus_0;
      this.$data.fuel_bonus_3 = this.$data.compatable_shift.fuel_bonus_3;
      this.$data.fuel_bonus_6 = this.$data.compatable_shift.fuel_bonus_6;
      this.$data.comment = this.$data.compatable_shift.comment;
    },
    onApproveSelected: function() {
      // can't approve free shift (has no `driver_id`)
      if ( +this.$data.select_time_sheet.driver_id == 0) {
        this.$store.dispatch('setError', 'Can\'t approve Open shift');
        return;
      }

      this.$v.$touch();
      let modified_shift_id = 0;
      if (this.cancel_fee_changed) {
        modified_shift_id = this.$data.select_time_sheet.shift_id? this.$data.select_time_sheet.shift_id: this.$data.select_time_sheet.modified_shift_id;
      }
      if (!this.$v.$invalid) {
        let time_sheet_data = {
          shift_id: this.$data.select_time_sheet.shift_id,
          restaurant_id: this.$data.restaurant_id,
          driver_id: this.$data.select_time_sheet.driver_id,
          status: STATUS_APPROVED,
          status_progress: STATUS_PROGRESS_PAY_APPROVED,
          period_date: moment(this.$data.period_date, "DD/MM/YYYY").format('YYYY-MM-DD'), // to ISO format
          start_time: this.$data.start_time,
          finish_time: this.$data.finish_time,
          meal_time: 0,
          rest_time: 0,
          cost_per_hour: this.$data.select_time_sheet.cost_per_hour, //!? get from shift
          cost_bonus: Number(this.$data.cost_bonus),
          const_fuel_bonus: this.$data.const_fuel_bonus,
          cost_extra_bonus: Number(this.$data.cost_extra_bonus),
          fuel_bonus_0: this.$data.fuel_bonus_0,
          fuel_bonus_3: this.$data.fuel_bonus_3,
          fuel_bonus_6: this.$data.fuel_bonus_6,
          // cost_total: this.$data.cost_total, //!
          comment: this.$data.comment,
          driver_comment: this.$data.driver_comment,
          modified_shift_id: modified_shift_id
        };
        const shift_data = {
          restaurant_id: this.$data.restaurant_id,
          driver_id: this.$data.select_time_sheet.driver_id,
          shift_id: this.$data.select_time_sheet.id,
          period_date: moment(this.$data.period_date, "DD/MM/YYYY").format('YYYY-MM-DD'),
          cost: Number(this.$data.cost_extra_bonus),
          comment_cancelled: this.$data.comment,
          model_type: MODEL_TYPE_SHIFTS,
          event: CANCELLED,
          model_id: modified_shift_id
        };
        // calc cost total
        let total_hours = this.getShiftHours(time_sheet_data);
        time_sheet_data.cost_total = +time_sheet_data.cost_per_hour *  +total_hours;

        // add bonus to cost total
        if (time_sheet_data.cost_bonus) {
          time_sheet_data.cost_total = parseFloat(time_sheet_data.cost_total) + +parseFloat(time_sheet_data.cost_bonus);
        }

        // add fuel bonus to cost total
        if (time_sheet_data.const_fuel_bonus) {
          time_sheet_data.cost_total = parseFloat(time_sheet_data.cost_total) + +parseFloat(time_sheet_data.const_fuel_bonus);
        }

        // if shift was discarded by driver then just change approve status
        if (this.$data.select_time_sheet.status_progress == STATUS_PROGRESS_DISCARDED_BY_DRIVER) {
          time_sheet_data.status_progress = STATUS_PROGRESS_DISCARDED_BY_DRIVER;
          // time_sheet_data.cost_total = this.$data.select_time_sheet.cost_total;
        }

        time_sheet_data.cost_total = time_sheet_data.cost_total.toFixed(2)

        if (this.$data.select_time_sheet.id > 0) {
          // time sheet exists, upgrade it
          time_sheet_data.id = this.$data.select_time_sheet.id;

          this.localLoading = true;
          this.$store.dispatch('editTimesheet', time_sheet_data).then(() => {
          }).finally(() => {
            this.localLoading = false;
          }).catch(error => {
              console.error('Error fetching data:', error);
              this.cancel_fee_changed = false; // Still set to false even if there's an error
            });
          if (this.cancel_fee_changed) {
              this.$store.dispatch('cancelShift', shift_data);
          }
        } else {
          // time sheet not exists, create new
          this.localLoading = true;

          this.$store.dispatch('createNewTimesheet', time_sheet_data).then((result) => {
            // find shift index and select
            let new_time_sheet_index = _.findIndex(this.timesheetListSearchedFilterDriver, p => +p.id == +result.id);
            this.onSelectTimeSheet(new_time_sheet_index);
          }).finally(() => {
            this.localLoading = false;
          });
        }
      }
    },
    onUnapproveTimeSelected: function() {
      const time_sheet_data = this.copyTimeSheet(this.$data.select_time_sheet);
      time_sheet_data.status = STATUS_PENDING;
      if (time_sheet_data.status_progress == STATUS_PROGRESS_DISCARDED_BY_DRIVER) {
        time_sheet_data.status_progress = STATUS_PROGRESS_DISCARDED_BY_DRIVER; // do not change status
      } else {
        time_sheet_data.status_progress = STATUS_PROGRESS_SUBMITED;
      }

      // -- send to server:
      this.localLoading = true;
      this.$store.dispatch('editTimesheet', time_sheet_data).then(() => {
      }).finally(() => {
        this.localLoading = false;
      });
    },
    onUnapprovePaySelected: function() {
      const time_sheet_data = this.copyTimeSheet(this.$data.select_time_sheet);
      time_sheet_data.status = STATUS_PENDING;
      if (time_sheet_data.status_progress == STATUS_PROGRESS_DISCARDED_BY_DRIVER) {
        time_sheet_data.status_progress = STATUS_PROGRESS_DISCARDED_BY_DRIVER; // do not change status
      } else {
        time_sheet_data.status_progress = STATUS_PROGRESS_TIME_APPROVED;
      }

      // -- send to server:
      this.localLoading = true;
      this.$store.dispatch('editTimesheet', time_sheet_data).then(() => {
      }).finally(() => {
        this.localLoading = false;
      });
    },
    onDiscardSelected: function() {
      // can't approve free shift (has no `driver_id`)
      if ( +this.$data.select_time_sheet.driver_id == 0) {
        this.$store.dispatch('setError', 'Can\'t discard Open shift'); // impossible
        return;
      }

      const time_sheet_data = this.copyTimeSheet(this.$data.select_time_sheet);
      time_sheet_data.status = STATUS_DISCARDED;
      if (time_sheet_data.status_progress == STATUS_PROGRESS_DISCARDED_BY_DRIVER) {
        time_sheet_data.status_progress = STATUS_PROGRESS_DISCARDED_BY_DRIVER; // do not change status
      } else {
        time_sheet_data.status_progress = STATUS_PROGRESS_DISCARDED;
      }

      // -- send to server:

      if (this.$data.select_time_sheet.id > 0) {
        // time sheet exists, upgrade it
        time_sheet_data.id = this.$data.select_time_sheet.id;

        this.localLoading = true;
        this.$store.dispatch('editTimesheet', time_sheet_data).then(() => {
        }).finally(() => {
          this.localLoading = false;
        });
      } else {
        // time sheet not exists, create new
        time_sheet_data.id = void 0;

        this.localLoading = true;
        this.$store.dispatch('createNewTimesheet', time_sheet_data).then(() => {
        }).finally(() => {
          this.localLoading = false;
        });
      }
    },
    onRemoveSelected: function() {
      if ( +this.$data.select_time_sheet.driver_id == 0) {
        this.$store.dispatch('setError', 'Can\'t remove Open shift'); // impossible
        return;
      }

      if (this.$data.select_time_sheet.id <= 0) {
        this.$store.dispatch('setError', 'Can\'t not remove submited Timesheet'); // impossible
        return;
      }

      if(!confirm('Remove timesheet ' + moment(this.$data.select_time_sheet.period_date, "YYYY-MM-DD").format('DD/MM/YYYY') + '?')) {
        return; // exit
      }

      this.localLoading = true;
      this.$store.dispatch('removeTimesheet', this.$data.select_time_sheet).then(() => {
        //
      }).finally(() => {
        this.localLoading = false;
      });

    },
    // -- select current time on click
    onStartTimeFocused: function() {
      if (!this.start_time) {
        this.start_time = this.timeToApproximation(moment().format('HH:mm'));
        this.start_time_was_clean = true;
      }
    },
    onStartTimeChanged: function() {
      this.$v.start_time.$touch();
      this.start_time_was_clean = false;
    },
    onStartTimeBlur: function () {
      if (this.start_time_was_clean) {
        this.start_time = void 0;
      }
      this.$v.start_time.$touch(); // fire validation
    },
    onFinishTimeFocused: function() {
      if (!this.finish_time) {
        this.finish_time = this.timeToApproximation(moment().format('HH:mm'));
        this.finish_time_was_clean = true;
      }
    },
    onFinishTimeChanged: function() {
      this.$v.finish_time.$touch();
      this.finish_time_was_clean = false;
    },
    onFinishTimeBlur: function () {
      if (this.finish_time_was_clean) {
        this.finish_time = void 0;
      }
      this.$v.finish_time.$touch(); // fire validation
    },
    // -- END select current time on click
    xlsExportTimesheets: function () {
      this.xlsExportLoading = true;
      this.$store.dispatch('requestXls', {
        period_date_from: this.$data.date_range_selected && this.$data.date_range_selected[0] ? this.$data.date_range_selected[0] : null,
        period_date_to: this.$data.date_range_selected && this.$data.date_range_selected[1] ? this.$data.date_range_selected[1] : null,
        restaurant_id: this.$data.location_selected && this.$data.location_selected.type == TYPE_RESTAURANT ? this.$data.location_selected.id : void 0
      }).then(() => {

      }).finally(() => {
        this.xlsExportLoading = false;
      });
    },
    generateInvoice: function () {
      if (!confirm("Are you sure want to regenerate the Invoice for the restaurant?")) {
        console.log("Cancelled");
        return;
      }
      this.localLoading = true;
      const response = this.$store.dispatch('requestInvoice', {
        period_date_from: this.$data.date_range_selected && this.$data.date_range_selected[0] ? this.$data.date_range_selected[0] : null,
        period_date_to: this.$data.date_range_selected && this.$data.date_range_selected[1] ? this.$data.date_range_selected[1] : null,
        restaurant_id: this.$data.location_selected && this.$data.location_selected.type == TYPE_RESTAURANT ? this.$data.location_selected.id : void 0
       }).then(() => {
        console.log("Generated!", response);
        alert("Generated successfully!");
        })
      .catch(() => {
        alert("Failed, please try again");
      })
      .finally(() => {
        this.localLoading = false;
      });
    },
    approvePeriodTimesheets: function() {
      let not_submited_timesheets = _.filter(this.timesheetListSearchedFilterDriver, p => {
        return p.status_progress == STATUS_PROGRESS_NOT_SUBMITED && p.driver_id;
      });

      let unapproved_timesheets = [];
      if (not_submited_timesheets.length > 0 && confirm('Also fill and approve ('+ not_submited_timesheets.length +') not submited timesheets?')) {
        unapproved_timesheets = _.filter(this.timesheetListSearchedFilterDriver, p => p.status == STATUS_PENDING && p.driver_id);
      } else {
        unapproved_timesheets = _.filter(this.timesheetListSearchedFilterDriver, p => p.status == STATUS_PENDING && p.status_progress != STATUS_PROGRESS_NOT_SUBMITED && p.driver_id);
      }

      if (unapproved_timesheets.length == 0) {
        return; // notheng to approve
      }

      if (!confirm('Approve ('+ unapproved_timesheets.length +') timesheets?')) {
        return; // exit
      }

      this.localLoading = true;
      this.approvePeriodLoading = true;

      // create not exits time sheets
      let result_timesheet_list = [];
      for (let i = 0;  i < unapproved_timesheets.length; i++) {

        let compatable_shift = _.find(this.shift_list, (p) => +p.id == unapproved_timesheets[i].shift_id);

        let time_sheet_data = {
          shift_id: unapproved_timesheets[i].shift_id,
          restaurant_id: unapproved_timesheets[i].restaurant_id ? unapproved_timesheets[i].restaurant_id : compatable_shift ? compatable_shift.restaurant_id : void 0,
          driver_id: unapproved_timesheets[i].driver_id,
          status: STATUS_APPROVED,
          status_progress: STATUS_PROGRESS_PAY_APPROVED,
          period_date: unapproved_timesheets[i].period_date ? unapproved_timesheets[i].period_date : compatable_shift ? compatable_shift.period_date : void 0,
          start_time: unapproved_timesheets[i].start_time ? unapproved_timesheets[i].start_time : compatable_shift ? moment(compatable_shift.start_time, "HH:mm").format('HH:mm') : void 0,
          finish_time: unapproved_timesheets[i].finish_time ? unapproved_timesheets[i].finish_time : compatable_shift ? moment(compatable_shift.finish_time, "HH:mm").format('HH:mm') : void 0,
          cost_per_hour: unapproved_timesheets[i].cost_per_hour, //!? get from shift
          cost_bonus: unapproved_timesheets[i].cost_bonus ? unapproved_timesheets[i].cost_bonus : compatable_shift ? compatable_shift.cost_bonus : 0,
          const_fuel_bonus: unapproved_timesheets[i].const_fuel_bonus ? unapproved_timesheets[i].const_fuel_bonus : compatable_shift ? compatable_shift.const_fuel_bonus : 0,
          cost_extra_bonus: unapproved_timesheets[i].cost_extra_bonus ? unapproved_timesheets[i].cost_extra_bonus : compatable_shift ? compatable_shift.cost_extra_bonus : 0,
          // cost_total: unapproved_timesheets[i].cost_total, //!
          comment: unapproved_timesheets[i].comment ? unapproved_timesheets[i].comment : void 0,
          driver_comment: unapproved_timesheets[i].driver_comment ? unapproved_timesheets[i].driver_comment : void 0,
          fuel_bonus_0: unapproved_timesheets[i].fuel_bonus_0 ? unapproved_timesheets[i].fuel_bonus_0 : 0,
          fuel_bonus_3: unapproved_timesheets[i].fuel_bonus_3 ? unapproved_timesheets[i].fuel_bonus_3 : 0,
          fuel_bonus_6: unapproved_timesheets[i].fuel_bonus_6 ? unapproved_timesheets[i].fuel_bonus_6 : 0,

        };

        // calc cost total
        let total_hours = this.getShiftHours(time_sheet_data);
        time_sheet_data.cost_total = +time_sheet_data.cost_per_hour * +total_hours;

        // add bonus to cost total
        if (time_sheet_data.cost_bonus) {
          time_sheet_data.cost_total = parseFloat(time_sheet_data.cost_total) + parseFloat(+time_sheet_data.cost_bonus);
        }

        // add Fuel bonus to cost total
        if (time_sheet_data.const_fuel_bonus) {
          time_sheet_data.cost_total = parseFloat(time_sheet_data.cost_total) + parseFloat(+time_sheet_data.const_fuel_bonus);
        }

        // if shift was discarded by driver then just change approve status
        if (unapproved_timesheets[i].status_progress == STATUS_PROGRESS_DISCARDED_BY_DRIVER) {
          time_sheet_data.status_progress = STATUS_PROGRESS_DISCARDED_BY_DRIVER;
          // time_sheet_data.cost_total = unapproved_timesheets[i].cost_total;
        }

        time_sheet_data.cost_total = time_sheet_data.cost_total.toFixed(2);

        if (unapproved_timesheets[i].id > 0) {
          // time sheet exists, upgrade it
          time_sheet_data.id = unapproved_timesheets[i].id;
        }
        result_timesheet_list.push(time_sheet_data);
      }

      this.$store.dispatch('approveTimesheets', result_timesheet_list).then((data) => {
        if (data && data.fail && data.fail.length > 0) {
          for(let i = 0; i < data.fail.length; i++) {
            let message = 'Can\'t approve timesheet ' + moment(data.fail[i].data.period_date, "YYYY-MM-DD").format('DD/MM/YYYY');
            let first_error = _.first(_.first(_.values(data.fail[i].errors)));
            if (first_error) {
              message += '. ' + first_error;
            }

            this.$store.dispatch('setError', message);
          }
        }
      }).finally(() => {
        this.localLoading = false;
        this.approvePeriodLoading = false;
      });
    },
    /**
     * make ckear copy of object to send into server
     **/
    copyTimeSheet: function(time_sheet) {
      const time_sheet_data = {
        id: time_sheet.id, //!
        shift_id: time_sheet.shift_id,
        restaurant_id: time_sheet.restaurant_id,
        driver_id: time_sheet.driver_id,
        status: time_sheet.status,
        status_progress: time_sheet.status_progress,
        period_date: time_sheet.period_date,
        start_time: time_sheet.start_time,
        finish_time: time_sheet.finish_time,
        meal_time: 0,
        rest_time: 0,
        cost_per_hour: time_sheet.cost_per_hour,
        cost_bonus: time_sheet.cost_bonus,
        const_fuel_bonus: time_sheet.const_fuel_bonus,
        cost_extra_bonus: time_sheet.cost_extra_bonus,
        cost_total: time_sheet.cost_total,
        comment: time_sheet.comment,
        driver_comment: time_sheet.driver_comment,
        fuel_bonus_0: time_sheet.fuel_bonus_0,
        fuel_bonus_3: time_sheet.fuel_bonus_3,
        fuel_bonus_6: time_sheet.fuel_bonus_6,
      };
      return time_sheet_data;
    },
    getAreaLabel: function(restaurant_id) {
      let restaurant = _.find(this.restaurant_list, p => +p.id == +restaurant_id);
      if (!restaurant) {
        return '-'; // impossible
      }

      let area = _.find(this.area_list, p => +p.id == +restaurant.area_id);
      if (!area) {
        return '-'; // impossible
      }

      return area.name;
    },
    // -- helpers:
    dayToRange: function(date, interval_id) {
        return DATE_RANGE_HELPERS.dayToRange(date, interval_id)
    },
    dateRangeText: function (date_range_selected) {
        return DATE_RANGE_HELPERS.dateRangeText(date_range_selected)
    },
    getPeriodDateText: function (period_date_selected) {
      return moment(period_date_selected, "YYYY-MM-DD").format('DD/MM/YYYY');
    },
    getShiftHours: function(shift_item) {
      return DATE_RANGE_HELPERS.getShiftHours(shift_item);
    },
    getDrvierNameById: function (driver_id) {
      let item = _.find(this.driver_list, p => p.id == driver_id);
      if (item) {
        return item.full_name;
      }

      return '-'; // await driver list loaded, or free shift
    },
    timeToApproximation: function(time_src) {
      let time_src_m = moment(time_src, "HH:mm:ss");
      if (!time_src_m.isValid()) {
          return time_src;
      }

      let time_item = _.find(this.timeList, p => {
        let time_item = moment(p.value, "HH:mm");
        let time_approximation = (time_item - time_src_m) / (1000 * 60 * 60)
        return time_approximation > -0.125;
      });

      if (time_item) {
        return time_item.value;
      }

      return time_src;
    },
    getRestaurantNameByID: function(restaurant_id) {
      let resturant = _.find(this.restaurant_list, p => +restaurant_id == +p.id);
      if (!resturant) {
        return '-';
      }

      return resturant.name;
    },
    scrollToCurrentLine() {
      const el = this.$el.getElementsByClassName('timeSheetItem_' + this.$data.select_time_sheet_index)[0];
      if (!el) {
        return; // exit
      }
      const y = el.offsetTop - 30;

      window.scrollTo({top: y, behavior: 'smooth'});
    },
    header2IsoDate: function (date) {
      return moment(date, "DD/MM/YYYY").format('YYYY-MM-DD');
    },
    moment: moment,
    calculateBonus() {
      this.const_fuel_bonus = (this.fuel_bonus_0*this.fuel_bonus_0_default) + (this.fuel_bonus_3*this.fuel_bonus_3_default) + (this.fuel_bonus_6*this.fuel_bonus_6_default);
    },
  },
  filters: {
    formatFloat: function (num) {
      return Number(num).toFixed(2);
    },
    formatHours: function (num) {
      return Number(num).toFixed(2);
    },
    headerDate: function (date) {
      return moment(date, "YYYY-MM-DD").format('DD/MM/YYYY');
    },
    formatTime: function (time) {
      if (!time) {
        return '__:__';
      }

      return moment(time, "HH:mm").format('HH:mm');
    },
    minutesToHourFormat: function (mins) {
      return moment.utc().startOf('day').add({ minutes: mins }).format('H:mm');
    },
  },
}
</script>

<style scoped>

  .select-drop-item-group__area {
    background: #e0e0e0;
  }

  .select-drop-item-sub_restaurant {
    padding-left: 16px;
  }

  .driver-list_leftpanel {
    padding-left: 0px;
    padding-right: 0px;
  }

  .driver-profile_icon {
    margin-right: 8px !important;
  }

  .bonus-plus {
    color: green;
    font-size: 12px;
  }

  .bonus-minus {
    color: #F44336;
    font-size: 12px;
  }

  .cost-total-result {
    font-size: 12px;
    font-weight: bold;
  }
  
  .driver-photo_src {
    max-width: 36px;
    max-height: 24px;
  }

  .summary_headline {
    font-size: 20px;
  }
</style>

<style>
  /* restore overloaded style */
  .multiselect__content-wrapper > ul.multiselect__content {
    padding-left: 0px;
  }

  .right-panel-work-area {
    width: 100%;
    overflow-x:auto;
    padding-bottom:48px;
    margin-left: 256px;
    margin-top: 47px;
  }

  .shift-total_value {
    font-weight: bold;
  }
</style>
